import React, { useState, useEffect } from 'react'
import CustomModal from '../CustomModal/CustomModal'
import useSconti from '../../hooks/useSconti';
import CustomSearch from '../CustomSearch/CustomSearch';
import useCorsi from '../../hooks/useCorsi';
import { Table, Button, Badge, Card, Form, Alert, Spinner, Accordion } from 'react-bootstrap';
import { alertService } from '../../services/AlertService';
import useMediaQuery from '../../hooks/useMediaQuery';
import { useSelector } from 'react-redux'; // <-- Import aggiunto
import { ROLES } from '../../model/roles'; // <-- Import aggiunto

export default function AssegnaScontoManager({selectedAgenzia, modalStateSconti, onHide}) {
  const isMobile = useMediaQuery('(max-width: 768px)');
  const { loadingStateSconti, createSconto, getScontiByIdAgenzia, getScontiByIdSuperpartner, deleteSconto } = useSconti();
  const { getCorsiByParams } = useCorsi();
  const userLoggedIn = useSelector(state => state.user.userData);
  const [selectedCourse, setSelectedCourse] = useState(null);
  const [formData, setFormData] = useState({
    sconto: ''
  });
  const [scontiUtente, setScontiUtente] = useState([]);
  const [scontiToDelete, setScontiToDelete] = useState([]);
  const [scontiToAdd, setScontiToAdd] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [marginiSuperpartner, setMarginiSuperpartner] = useState({});

  console.log(selectedCourse);

  useEffect(() => {
    if (selectedAgenzia) {
      loadScontiAgenzia();
    }
  }, [selectedAgenzia]);

  /*
  const loadScontiAgenzia = async () => {
    setIsLoading(true);
    try {
      const sconti = await getScontiByIdAgenzia(selectedAgenzia.id_agenzia);
      setScontiUtente(sconti);
      setScontiToDelete([]);
      setScontiToAdd([]);
    } catch (error) {
      console.error('Errore nel caricamento sconti:', error);
    } finally {
      setIsLoading(false);
    }
  };
  */

  // --- SOSTITUISCI QUESTA INTERA FUNZIONE ---
  const loadScontiAgenzia = async () => {
      setIsLoading(true);
      try {
          // Carica gli sconti già assegnati all'entità (Agenzia o Superpartner)
          let scontiAssegnati;
          if (selectedAgenzia.id_agenzia) {
              scontiAssegnati = await getScontiByIdAgenzia(selectedAgenzia.id_agenzia);
          } else if (selectedAgenzia.id_superpartner) {
              scontiAssegnati = await getScontiByIdSuperpartner(selectedAgenzia.id_superpartner);
          }
          setScontiUtente(scontiAssegnati || []);

          // SE l'utente loggato è un Superpartner, carica anche i suoi margini disponibili
          if (userLoggedIn.role === ROLES.SUPERPARTNER) {
              const scontiSP = await getScontiByIdSuperpartner(userLoggedIn.id_superpartner);
              // Trasformiamo l'array in un oggetto per una ricerca più facile (mappa da id_corso -> sconto)
              const marginiMap = (scontiSP || []).reduce((acc, sconto) => {
                  acc[sconto.id_corso] = sconto.sconto;
                  return acc;
              }, {});
              setMarginiSuperpartner(marginiMap);
          }

          setScontiToDelete([]);
          setScontiToAdd([]);
      } catch (error) {
          console.error('Errore nel caricamento sconti:', error);
      } finally {
          setIsLoading(false);
      }
  };

  const handleSearch = async (params) => {
    const response = await getCorsiByParams(params);
    return response;
  };

const handleFormChange = e => {
    const { name, value } = e.target;

    if (name === 'sconto') {
        // Se l'utente cancella il campo, aggiorna lo stato a vuoto e termina
        if (value === '') {
            setFormData(prevState => ({ ...prevState, sconto: '' }));
            return;
        }

        // 1. Controlla che l'input sia in un formato numerico valido (permette cifre e un punto)
        const numericStringRegex = /^\d*\.?\d*$/;
        if (!numericStringRegex.test(value)) {
            return; // Ignora l'input se non è numerico
        }

        const numValue = parseFloat(value);

        // 2. Controlla se il valore è un numero valido dopo la conversione
        if (isNaN(numValue) && value !== '.') {
            return; 
        }

        // 3. Controlla se il valore supera il massimo consentito dall'attributo 'max'
        const maxAttr = e.target.getAttribute('max');
        if (maxAttr !== null) {
            const maxValue = parseFloat(maxAttr);
            if (!isNaN(maxValue) && numValue > maxValue) {
                // Se il valore inserito supera il massimo, imposta il valore al massimo consentito
                setFormData(prevState => ({ ...prevState, sconto: maxValue.toString() }));
                alertService.warn(`Lo sconto non può superare il margine di ${maxValue.toFixed(2)} €.`);
                return;
            }
        }

        // 4. Se tutti i controlli sono superati, aggiorna lo stato
        setFormData(prevState => ({ ...prevState, sconto: value }));

    } else {
        // Gestione per tutti gli altri campi del form
        setFormData(prevState => ({ ...prevState, [name]: value }));
    }
  };

  const handleAddSconto = () => {
    if (!selectedCourse || !formData.sconto) return;

    const existingSconto = [...scontiUtente, ...scontiToAdd].find(
      s => s.id_corso === selectedCourse.id_corso
    );

    if (existingSconto) {
      alertService.warn("Esiste già uno sconto per questo corso", {autoClose: true});
      return;
    }

    const newSconto = {
      id_corso: selectedCourse.id_corso,
      id_classe: selectedCourse?.classi[0].id_classe,//NEW
      nome_corso: selectedCourse.denominazione,
      sconto: Number(formData.sconto).toFixed(2),
      data_inserimento: new Date().toISOString(),
      isNew: true
    };

    setScontiToAdd(prev => [...prev, newSconto]);
    setSelectedCourse(null);
    setFormData({ sconto: '' });
  };

  /*
  const handleSave = async () => {

    for (const idSconto of scontiToDelete) {
      await deleteSconto({id_sconto: idSconto});
    }

    
    
    for (const sconto of scontiToAdd) {
      await createSconto({
        id_agenzia: selectedAgenzia.id_agenzia, // <-- USA L'ID DELL'AGENZIA
        id_superpartner: userLoggedIn.id_superpartner, // Passiamo anche l'ID del SP che sta agendo
        id_corso: sconto.id_corso,
        id_classe: sconto.id_classe,//NEW
        sconto: sconto.sconto
      });
    }

    onHide();
  }
  */
const handleSave = async () => {
    for (const idSconto of scontiToDelete) {
        await deleteSconto({ id_sconto: idSconto });
    }

    for (const sconto of scontiToAdd) {
        // 1. Creiamo un oggetto base
        let dataToSend = {
            id_corso: sconto.id_corso,
            id_classe: sconto.id_classe,
            sconto: sconto.sconto
        };
        if (selectedAgenzia.id_agenzia) {
            dataToSend.id_agenzia = selectedAgenzia.id_agenzia;
        }  
        if (selectedAgenzia.id_superpartner) {
            dataToSend.id_superpartner = selectedAgenzia.id_superpartner;
        }
        
        // 3. Inviamo l'oggetto completo
        await createSconto(dataToSend);
    }
    onHide();
};

  const handleDeleteSconto = (sconto) => {
    if (sconto.isNew) {
      setScontiToAdd(prev => prev.filter(s => s.id_corso !== sconto.id_corso));
    } else {
      setScontiToDelete(prev => [...prev, sconto.id_sconto]);
      setScontiUtente(prev => prev.filter(s => s.id_sconto !== sconto.id_sconto));
    }
  };

 const renderScontiList = () => (
    <div className="mt-4">
      <h6 className="mb-3">Sconti assegnati</h6>
      {isLoading ? (
        <div className="text-center py-3">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Caricamento...</span>
          </div>
        </div>
      ) : [...scontiUtente, ...scontiToAdd].length > 0 ? (
        isMobile ? (
          // La tua vista mobile a schede
          <div className="d-flex flex-column gap-3">
            {[...scontiUtente, ...scontiToAdd].map((sconto) => (
              <Card 
                key={sconto.id_sconto || sconto.id_corso} 
                className={sconto.isNew ? 'border-success bg-success bg-opacity-10' : ''}
              >
                <Card.Body>
                  <div className="d-flex justify-content-between align-items-start mb-2">
                    <div>
                      <h6 className="mb-1">{sconto.nome_corso}</h6>
                      <Badge bg="success" className="me-2">€ {Number(sconto.sconto).toFixed(2)}</Badge>
                    </div>
                    <Button 
                      variant="outline-danger" 
                      size="sm"
                      onClick={() => handleDeleteSconto(sconto)}
                    >
                      <i className="bi bi-trash3"></i>
                    </Button>
                  </div>
                  <small className="text-muted">
                    Assegnato il: {new Date(sconto.data_inserimento).toLocaleDateString()}
                  </small>
                </Card.Body>
              </Card>
            ))}
          </div>
        ) : (
          // Vista Tabella per Desktop con le correzioni grafiche
          <div className="table-responsive">
            <Table hover className="align-middle mb-0" style={{ tableLayout: 'fixed' }}>
              <thead className="table-light">
                <tr>
                  <th style={{ width: '50%' }}>Corso</th>
                  <th style={{ width: '20%' }}>Importo Sconto</th>
                  <th style={{ width: '20%' }}>Data Assegnazione</th>
                  <th style={{ width: '10%' }} className="text-end">Azioni</th>
                </tr>
              </thead>
              <tbody>
                {[...scontiUtente, ...scontiToAdd].map((sconto) => (
                  <tr key={sconto.id_sconto || sconto.id_corso} className={sconto.isNew ? 'table-success' : ''}>
                    {/* CORREZIONE: Stili per forzare il testo a capo */}
                    <td style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
                      {sconto.nome_corso}
                    </td>
                    <td>
                      <Badge bg="success">€ {Number(sconto.sconto).toFixed(2)}</Badge>
                    </td>
                    <td>{new Date(sconto.data_inserimento).toLocaleDateString()}</td>
                    <td className="text-end">
                      <Button 
                        variant="outline-danger" 
                        size="sm"
                        onClick={() => handleDeleteSconto(sconto)}
                      >
                        <i className="bi bi-trash3"></i>
                      </Button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        )
      ) : (
        <p className="text-muted text-center">Nessuno sconto assegnato</p>
      )}
    </div>
  );

  const renderBody = () => (
    <div className='container-fluid px-0'>
      <div className='row'>
        <div className='col-12 mb-1'>
          <CustomSearch
            field={"denominazione"}
            label={"Cerca corso"}
            searchApi={handleSearch}
            placeholder={"Nome del corso"}
            selectedItem={selectedCourse}
            setSelectedItem={setSelectedCourse}
          />
          {selectedCourse && (
            <div className='mt-2'>
              <span className='small text-muted d-block mb-1'><b>Corso selezionato</b></span>
              <span>{selectedCourse?.denominazione} ({selectedCourse?.codice})</span>
            </div>    
          )}
        </div>
        <div className='col-12'>
            {/* Mostra un avviso con il margine disponibile solo per il Superpartner */}
            {userLoggedIn.role === ROLES.SUPERPARTNER && selectedCourse && (
                <Alert variant="info" className="mt-3">
                    Il tuo margine di sconto per questo corso è: <strong>{marginiSuperpartner[selectedCourse.id_corso] || '0.00'} €</strong>
                </Alert>
            )}

            <div className="d-flex gap-2">
                <div className="flex-grow-1">
                    <span className='small text-muted d-block mb-1'><b>Importo sconto (€)</b></span>
                    <input 
                        name="sconto" 
                        value={formData.sconto} 
                        onChange={handleFormChange} 
                        className="form-control" 
                        type="number"
                        // Limita l'input al margine del Superpartner, se presente
                        max={userLoggedIn.role === ROLES.SUPERPARTNER ? (marginiSuperpartner[selectedCourse?.id_corso] || 0) : undefined}
                        placeholder="Inserisci l'importo"
                    />
                </div>
                <div className="align-self-end">
                    <Button 
                        variant="primary"
                        onClick={handleAddSconto}
                        disabled={!selectedCourse || !formData.sconto}
                    >
                        Aggiungi
                    </Button>
                </div>
            </div>
        </div>
      </div>
      {renderScontiList()}
    </div>
  );

  return (
    <CustomModal
      title={`Assegna sconto a ${selectedAgenzia?.denominazione}`}
      body={renderBody()}
      isLoading={loadingStateSconti.isLoadingScontoCreating || loadingStateSconti.isLoadingScontoDeleting}
      onSave={handleSave}
      onHide={onHide}
      btnText={"Salva"}
      show={modalStateSconti.showModalCreateSconto}
      size="xl"
      onUndoChanges={onHide}
    />
  );
}
